import React from "react";
import ReactDOM from "react-dom";

import ThemeProvider from "styles/themeProvider";

import { Router } from "routes/router";
import GlobalStyles from "styles/global";

function App() {
  return (
    <ThemeProvider>
      <GlobalStyles />
      <Router />
    </ThemeProvider>
  );
}

ReactDOM.render(<App />, document.getElementById("root"));
